import { inVisionCap } from "../nameplates/layout.ts";

/**
 * Whether an emoji over a drawn character may show this frame (ADR-114 decisions 5.7 and 5.8), before its art and its
 * place on the canvas are asked: not while the character's world UI hides (concealed from the viewer and not targeted,
 * ADR-061's rule 4), not for another character while the viewer has turned other players' emotes off, the viewer's own
 * always shown, and not outside the vision cap around the local character, as a name plate is hidden there.
 *
 * @param hidden Whether the character's world UI hides.
 * @param own Whether the character is the viewer's own.
 * @param others The viewer's Show other players' emotes choice.
 * @param dx The character's feet across from the local character's, in world pixels.
 * @param dy The same down.
 * @returns True when the emoji may show.
 * @example
 * emojiMayShow(false, false, true, 64, 0);
 * // true: another player two tiles to the side, other players' emotes on
 */
export function emojiMayShow(hidden: boolean, own: boolean, others: boolean, dx: number, dy: number): boolean {
  return !hidden && (own || others) && inVisionCap(dx, dy);
}
